;
define("storelocator_accesspoints_headerlink.tpl", function(){});

